import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const PH = ({ children }) => (
  <span className="rounded bg-purple-100 px-1.5 py-0.5 font-semibold text-purple-700">{children}</span>
);

export const LegalH2 = ({ children }) => (
  <h2 className="mt-7 font-heading text-base font-bold text-slate-900">{children}</h2>
);

export const LegalP = ({ children }) => (
  <p className="mt-3 text-xs leading-relaxed text-slate-600">{children}</p>
);

export const LegalList = ({ items }) => (
  <ul className="mt-3 list-disc space-y-1.5 pl-5 text-xs leading-relaxed text-slate-600">
    {items.map((item) => (
      <li key={item}>{item}</li>
    ))}
  </ul>
);

export const LegalLayout = ({ title, updated, children, testid }) => (
  <div data-testid={testid} className="min-h-screen bg-white">
    <header className="sticky top-0 z-50 border-b border-purple-100 bg-white/90 backdrop-blur-xl">
      <div className="mx-auto flex max-w-3xl items-center justify-between px-5 py-3">
        <Link to="/" data-testid="legal-logo-link" className="flex items-center">
          <img src="/logo.png" alt="MIR-IA" className="h-8 w-auto" />
        </Link>
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-purple-700 transition-colors hover:text-purple-900"
        >
          <ArrowLeft className="h-4 w-4" /> Torna alla home
        </Link>
      </div>
    </header>
    <main className="mx-auto max-w-3xl px-5 py-12">
      <h1 className="font-heading text-2xl font-extrabold tracking-tight text-slate-900">{title}</h1>
      <p className="mt-2 text-xs text-slate-400">Ultimo aggiornamento: {updated}</p>
      {children}
    </main>
  </div>
);
